import { createSlice } from "@reduxjs/toolkit";
import { defaultFlightShopGroupFilter, defaultFlightShopsFilter } from "../../utils/constants/constants";

const myMarketFilterFormData = {...defaultFlightShopsFilter}
const shopGroupFilterFormData = {...defaultFlightShopGroupFilter}

const FilterFormSlice = createSlice({
    name: "filterForms",
    initialState: {
        myMarketFilterFormData,
        shopGroupFilterFormData,
    },
    reducers: {
        reSetMyMarketFilterFormData(state, action){
            state.myMarketFilterFormData = {...defaultFlightShopsFilter}
            state.shopGroupFilterFormData = {...defaultFlightShopGroupFilter}
        },
        setMyMarketFilterFormData(state, action) {
            state.myMarketFilterFormData = action.payload;
        },
        setShopGroupFilterFormData(state, action) {
            state.shopGroupFilterFormData = action.payload;
        },
    },
});

export const {
    setMyMarketFilterFormData,
    setShopGroupFilterFormData,
    reSetMyMarketFilterFormData
} = FilterFormSlice.actions;

export default FilterFormSlice.reducer;
